<template>
  <section id="container" class="gnb_pdt">
    <div>
      <div class="title_wrap">
        <h1> 일렉트론 앱 버전 상세</h1>
      </div>
    </div>
    <!--  기본 정보  -->
    <div class="contents_wrap">
      <ul class="filter_list">
        <li>
          <dd>
            <label>버전 명</label>
            <ul class="w75">
              <li>
                {{versionInfo.versionNm}}
              </li>
            </ul>
          </dd>
          <dd>
            <label>타입</label>
            <ul class="w75">
              <template v-for="item in kioskUseScnList ">
                <li v-if="item.cdId == versionInfo.kioskType">
                  {{item.cdNm}}
                </li>
              </template>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>생성 일시</label>
            <ul class="w75">
              <li>
                {{ versionInfo.frstRgstDt }}
              </li>
            </ul>
          </dd>
          <dd>
            <label>버전 활성화</label>
            <ul class="w75">
              <li v-if="versionInfo.useYn == 'Y'" >
                {{ '활성화' }}
              </li>
              <li v-else>
                {{ '비활성화' }}
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>일렉트론 앱 버전 업로드</label>
            <ul class="w50">
              <li v-show="versionInfo.fileId" @click="getDownloadFile">
                <div class="blue"><span class="k-icon k-i-download blue"></span>
                {{ versionInfo.orgFileNm}}
                </div>
              </li>
            </ul>
          </dd>
          <dd>
            <label>설명</label>
            <ul class="w75">
              <ul class="w75">
                <li>
                  {{ !!versionInfo.summary ? versionInfo.summary : '-' }}
                </li>
              </ul>
            </ul>
          </dd>
        </li>
        <li>
          <dd>
            <label>적용 키오스크</label>
            <ul>
              <li v-for="item in versionKioskList" class="f_l w50">
                {{ item.kioskNm }}
              </li>
            </ul>
          </dd>
        </li>
        <!--  키오스크 담당자 매칭, 임직원 목록 db, 관리자 db 업데이트 되면 추후 수정  -->
      </ul>
    </div>
    <!--  상세 설명  -->
    <div class="contents_wrap">
      <ul class="filter_list">
        <li>
          <label style="width: 9.5%;">상세 설명</label>
          <ul class="w75">
            <li>
              {{ !!versionInfo.description ? versionInfo.description : '-' }}
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <!--  버튼 영역  -->
    <div class="button_area w30">
      <ul>
        <li class="w25">
          <button type="submit" class="large_btn orange" @click="redirectToUpdate"> 수정 </button>
        </li>
        <li class="w25">
          <button type="button" class="large_btn" @click="redirectToList">목록</button>
        </li>
      </ul>
    </div>
  </section>
</template>
<script>

import { LogisticsCodeDtlMixin, ZoneMixin } from '@/mixin/Mixin'
import DaumPostcodeWindow from '@/components/DaumPostcodeWindow.vue'
import SearchSendNm from '@/components/send/SearchSendNm.vue'
import ApiUtil from '@/api/api.util'
import Apiconfig from '@/api/api.config'
import { ListBox } from '@progress/kendo-listbox-vue-wrapper'
import SendFileUpload from '@/components/send/SendFileUpload.vue'
import ApiConfig from '@/api/api.config'

export default {
  name: 'VersionDetail',
  components: {
    SendFileUpload,
    'kendo-listbox': ListBox
  },
  mixins: [LogisticsCodeDtlMixin],
  created () {
    const vm = this
    vm.getVersionInfo()
  },
  mounted () {
  },
  computed: {
  },
  methods: {
    // 버전 정보 호출 API
    getVersionInfo () {
      const vm = this
      const url = `${Apiconfig.eklDomain}/v1/ebmp/ai/manager/portal/electron/versionDetail.json`
      const params = {
        loginUserToken: vm.loginUserToken,
        versionId: vm.$route.params.versionId,
      }
      ApiUtil.post(url, params).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        const resultData = response.data.resultData
        vm.versionInfo = resultData
        vm.versionKioskList = resultData.versionKioskList
      })
    },
    // 버전 다운로드
    getDownloadFile () {
      const vm = this
      const downloadUrl = `${Apiconfig.eklDomain}/files/${vm.versionInfo.solCd}/${vm.versionInfo.fileId}/0?lutk=${vm.loginUserToken}`
      const a = document.createElement('a')
      a.href =  downloadUrl
      a.download = `${vm.versionInfo.versionNm}.exe`
      document.body.appendChild(a)
      a.click();
      document.body.removeChild(a);
    },
    // 목록 으로 이동
    redirectToList () {
      // 목록으로 포워딩
      this.$router.push({
        name: 'VersionList'
      })
    },
    // 수정 으로 이동
    redirectToUpdate() {
      // lockerId 등록(수정)으로 전달
      const vm = this
      this.$router.push({
        name: "VersionUpdate",
        params: {
          versionId: vm.versionInfo.versionId,
        }
      })
    },
  },

  data () {
    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      versionInfo:[],
      kioskList: [],
      selectedList: [],
      versionKioskList: [],
      updateVersionList: [],
      removeVersionList: [],
    }
  }
}
</script>
